import { actionTypes } from "./actions";

export const initialState = {
  areaList: []
};

// ===========================|| COMMON REDUCER ||=========================== //

const areaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AREA_GET_REQUEST:
      return {
        ...state,
        isAreaLoading: true,
      };
    case actionTypes.AREA_GET_RECEIVE:
      return {
        ...state,
        areaList: action.payload.map((dt, index) => ({ ...dt, id: index })),
        isAreaLoading: false,
      };
    case actionTypes.AREA_GET_FAIL:
      return {
        ...state,
        isAreaLoading: false,
        isAreaFail: false,
      };
    default:
      return state;
  }
};

export default areaReducer;
